import { useCallback } from 'react';
import { DocumentPart } from 'Interfaces/Document';
import { orderBy } from 'lodash-es';

export default () => {
  const getPages = useCallback((files: DocumentPart[]) => {
    const orderedFiles = orderBy(files, 'order', 'asc');
    return orderedFiles.map(file => file.pdfFileKey) as string[];
  }, []);

  return getPages;
};
